<template>
  <div>
    <v-row>
      <v-col cols="12" sm="9"> 
        <div v-if="!pdfUrl">
           <h2>{{ msg }}</h2>
        </div>
        <div v-if="pdfUrl">
          <iframe 
            ref="pdfIframe" 
            :src="pdfUrl" 
            style="width: 100%; height: 800px; border: 1px solid #ccc;" 
            frameborder="0"
          ></iframe>
        </div>
      </v-col>
      <v-col cols="12" sm="3"> 
       <MainLedgerDetailListVertical />
      </v-col>
    </v-row>
  </div>
</template>

<script>

import MainLedgerService from '@/services/MainLedgerService'
import MainLedgerDetailListVertical from './MainLedgerDetailListVertical'

export default {
  name: '',
  props: [],
  data: ()=> ({
    pdfUrl: null,
    mainledger: null,
    msg: 'Sorry, not attached document! Nema dokumenta u privitku!'
  }),
  async mounted () {
    this.mainledger = this.$store.state.mainledgerActiv ? this.$store.state.mainledgerActiv : {}
    if (this.mainledger.MLFree2) {
      await this.showPdf(this.mainledger.MLFree5)
    }
  },
  methods: {
      async showPdf(params) {
        if (this.doDelete) {
          return
        }
        console.log('params ', params)
        if (params) {
          const showFile ={
            showFile: params
          }
        this.revokeCurrentUrl();

        await MainLedgerService.showPdf(showFile)
        .then(res => {
          const data = res.data
  
          var byteCharacters = atob(data);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], { type: "application/pdf" });

          //FileSaver.saveAs(blob, "invoice.pdf")

          // // const zoveSe = this.mainledger.MLFree2 ? this.mainledger.MLFree2 : 'Book'
          //const header = res.headers
          //const fileType = header['content-type']
          //const file = new Blob([data], {type: fileType})
          // eslint-disable-next-line
          //console.log(' have file ', blob)
          this.pdfUrl = URL.createObjectURL(blob);

          // -->> const fileurl = window.URL.createObjectURL(blob)
          // -->window.open(fileurl)

          //FileSaver.saveAs(file, 'invoice.pdf');
        }).catch(error => {
          this.text = 'Error ' + error
          this.color = 'red'
          this.snackbar = true
        })
      }
    },
    revokeCurrentUrl() {
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
        console.log('Previous PDF Object URL revoked.');
        // Optionally set pdfUrl to null if you want to clear the iframe content
        // this.pdfUrl = null; 
      }
    },
  },
  computed: {
  },
  watch: {

  },
  components: {
    MainLedgerDetailListVertical
  }

}

</script>